import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  //BubbleController,
  DoughnutController,
  LineController,
  //PieController,
  //PolarAreaController,
  //RadarController,
  //ScatterController,
  //CategoryScale,
  LinearScale,
  //LogarithmicScale,
  //RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  //Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';

import 'chartjs-adapter-date-fns';
import { de } from 'date-fns/locale';
import { fr } from 'date-fns/locale';
import { it } from 'date-fns/locale';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  //BubbleController,
  DoughnutController,
  LineController,
  //PieController,
  //PolarAreaController,
  //RadarController,
  //ScatterController,
  //CategoryScale,
  LinearScale,
  //LogarithmicScale,
  //RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  //Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
);

window.Chart = Chart;
window.chartDe = de;
window.chartFr = fr;
window.chartIt = it;
